export default __webpack_public_path__ + "static/media/illustCopy@3x.81b754e8.png";